export default "__VITE_ASSET__BgZbwrls__"